import { ActionIcon, Flex, Tooltip } from '@mantine/core';

import TrashIcon from '@/assets/icons/content/trash.svg';

import type { CellContext } from '@tanstack/react-table';
import type { ApiKeyResponse, ApiKeysTableMeta } from './types';

const ActionsCell = ({ row, table }: CellContext<ApiKeyResponse, unknown>) => {
  const meta = table.options.meta as ApiKeysTableMeta;
  const key = row.original;

  return (
    <Flex justify="center">
      <Tooltip label="Delete key">
        <ActionIcon
          size={24}
          variant="subtle"
          color="var(--quo-pink)"
          aria-label={`Delete key ${key.name}`}
          onClick={() => meta.onDelete(key)}
        >
          <TrashIcon />
        </ActionIcon>
      </Tooltip>
    </Flex>
  );
};

export default ActionsCell;
